import React, { createContext, useContext, useState } from 'react';
import { fetchPostData } from '@/Components/hooks/Api';
import { sixColArrayArrest } from '@/Components/Common/ChangeArrayFormat';

const NameContext = createContext();

export const NameProvider = ({ children }) => {
  const [nameData, setNameData] = useState([]);
  const [nameFilterData, setNameFilterData] = useState([]);
  const [nameStatus, setNameStatus] = useState();
  const [nameSearchData, setNameSearchData] = useState([]);
  const [nameSearchStatus, setNameSearchStatus] = useState(false);
  const [nameSingleData, setNameSingleData] = useState([]);
  const [nameShowPage, setNameShowPage] = useState('home');
  const [NameTabCount, setNameTabCount] = useState([]);
  const [MasterNameTabCount, setMasterNameTabCount] = useState([]);
  const [NameVictimCount, setNameVictimCount] = useState([]);
  const [NameId, setNameID] = useState('');
  const [countStatus, setcountStatus] = useState(false);
  const [countAppear, setcountAppear] = useState(false);
  const [auditCount, setAuditCount] = useState(false);
  const [victimCount, setVictimCount] = useState(false);
  const [offenderCount, setOffenderCount] = useState(false);
  const [offenceCountStatus, setoffenceCountStatus] = useState(false);
  const [masterCountgenStatus, setMasterCountgenStatus] = useState(false);
  const [masterAppeaCountStatus, setmasterAppeaCountStatus] = useState(false);
  const [personNotifyDrp, setpersonNotifyDrp] = useState([]);

  const get_Data_Name = (NameID) => {
    if (NameID == null) return Promise.resolve();
    return fetchPostData('MasterName/GetData_MasterName', { IncidentID: NameID }).then((res) => {
      setNameData(res || []);
      setNameFilterData(res || []);
    });
  };

  const get_Name_Count = (NameID, masterID, IsMaster) => {
    fetchPostData('HomeApi/GetData_NameCount', { NameID, MasterNameID: masterID, IsMaster }).then((res) => {
      setNameTabCount(res?.[0] || []);
    });
  };

  const get_MasterName_Count = (NameID, masterID, IsMaster) => {
    fetchPostData('HomeApi/GetData_NameCount', { NameID, MasterNameID: masterID, IsMaster }).then((res) => {
      setMasterNameTabCount(res?.[0] || []);
    });
  };

  const get_NameVictim_Count = (VictimID) => {
    fetchPostData('NameVictimCount/GetData_NameVictimCount', { VictimID }).then((res) => {
      setNameVictimCount(res?.[0] || []);
    });
  };

  const get_NameOffender_Count = (NameID) => {
    fetchPostData('NameVictimCount/GetData_NameOffenderCount', { NameID }).then((res) => {
      setNameTabCount(res?.[0] || []);
    });
  };

  const get_MissingPerson_NotifyDrp = (IncidentID, MissingPersonID, IsPersonToBeNotified) => {
    fetchPostData('MissingPerson/GetDropDown_PersonToByNotified', {
      IncidentID,
      MissingPersonID,
      IsPersonToBeNotified: !!IsPersonToBeNotified,
    }).then((data) => {
      setpersonNotifyDrp(
        sixColArrayArrest(
          data || [],
          'NameID',
          'Arrestee_Name',
          'LastName',
          'DateOfBirth',
          'Gendre_Description',
          'Race_Description',
          'NameID',
          'MasterNameID',
          'AgeFrom',
          'IsJuvenile'
        )
      );
    });
  };

  const get_MissingPerson_Count = (MissingPersonID, loginPinID) => {
    fetchPostData('MissingPerson/GetData_MissingPersonCount', { MissingPersonID, PINID: loginPinID }).then((res) => {
      setNameTabCount(res?.[0] || []);
    });
  };

  return (
    <NameContext.Provider
      value={{
        nameData,
        nameFilterData,
        setNameFilterData,
        nameStatus,
        setNameStatus,
        nameSearchData,
        setNameSearchData,
        nameSearchStatus,
        setNameSearchStatus,
        nameSingleData,
        setNameSingleData,
        nameShowPage,
        setNameShowPage,
        NameTabCount,
        setNameTabCount,
        MasterNameTabCount,
        setMasterNameTabCount,
        NameVictimCount,
        setNameVictimCount,
        NameId,
        setNameID,
        countStatus,
        setcountStatus,
        countAppear,
        setcountAppear,
        auditCount,
        setAuditCount,
        victimCount,
        setVictimCount,
        offenderCount,
        setOffenderCount,
        offenceCountStatus,
        setoffenceCountStatus,
        masterCountgenStatus,
        setMasterCountgenStatus,
        masterAppeaCountStatus,
        setmasterAppeaCountStatus,
        personNotifyDrp,
        setpersonNotifyDrp,
        get_Data_Name,
        get_Name_Count,
        get_MasterName_Count,
        get_NameVictim_Count,
        get_NameOffender_Count,
        get_MissingPerson_NotifyDrp,
        get_MissingPerson_Count,
      }}
    >
      {children}
    </NameContext.Provider>
  );
};

export const useName = () => {
  const context = useContext(NameContext);
  if (!context) throw new Error('useName must be used within NameProvider');
  return context;
};

export default NameContext;
